import { useQuery } from 'react-query';
import { dataSelector } from '@nextiva/global-store';
import { useSelector } from 'react-redux';

import { getConsentGrantStatus } from 'services/consentGrantStatus/consentGrantStatusService';
import { GlobalStoreInterface } from 'interface/globalStore';

export const useGetConsentGrantStatus = () => {
  const globalStoreData: GlobalStoreInterface | undefined = useSelector(
    dataSelector,
  );
  return useQuery(
    ['consentGrantStatus', globalStoreData.sso],
    () =>
      getConsentGrantStatus(
        globalStoreData.sso,
        String(globalStoreData?.user?.accountInfo?.corpAcctNbr),
      ),
    {
      enabled: !!globalStoreData.sso,
      retry: 1,
      refetchOnWindowFocus: false,
    },
  );
};
